// extracted by mini-css-extract-plugin
export default {"icon":"BuyMeACoffeeLink_icon__8ZrRg"};